import Callout from "../../../../src/components/callouts/callouts";
import Btn from "../../../../src/components/buttons/buttons";
import Links from "../../../../src/components/links/links";
import Procedimiento from "../../../../src/components/pagesPartials/procedimientoCambiarme/procedimientoCambiarme";
import { BASE_URL_TRASPASO } from "../../../../src/constants/URLs";
import * as React from 'react';
export default {
  Callout,
  Btn,
  Links,
  Procedimiento,
  BASE_URL_TRASPASO,
  React
};